module.exports = __webpack_public_path__ + "static/media/CEU.d1f7bb2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CEU.svg
// module id = 220
// module chunks = 0